// router/index.js
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import i18n from '../i18n'
import Home from '../views/Home.vue'
import Privacy from '../views/Privacy.vue'
import News from '../views/News.vue'
import NewsArticle from '../views/NewsArticle.vue'
import Product from '../views/Product.vue'
import AllProduct from '../views/AllProduct.vue'
import cookiepolicy from '../views/cookiepolicy.vue'
import Member from '../views/Member.vue'
import Institute from '../views/Institute.vue'

// 登入後主頁殼層與子頁面
import AppShell from '../views/AppShell.vue'
import PromoList from '../views/AppShell/PromoList.vue'
import PromoListDetail from '../views/AppShell/PromoListDetail.vue'
import Products from '../views/AppShell/Products.vue'
import Product_detal from '../views/AppShell/Product_detal.vue'
import Papers from '../views/AppShell/Papers.vue'
import PaperDetail from '../views/AppShell/PaperDetail.vue'
import Share from '../views/AppShell/Share.vue'
import Download from '../views/AppShell/Download.vue'
import Cart from '../views/AppShell/Cart.vue'
import AppTrial from '../views/AppShell/AppTrial.vue'
import Profile from '../views/AppShell/Profile.vue'
import Contact from '../views/AppShell/Contact.vue'

// ✅ 影音四頁（含小主題頁）
const VideoIndex    = () => import('@/views/AppShell/Videos/VideoIndex.vue')
const TopicVideos   = () => import('@/views/AppShell/Videos/TopicVideos.vue')
const SubtopicVideo = () => import('@/views/AppShell/Videos/SubtopicVideo.vue')
const VideoPlay     = () => import('@/views/AppShell/Videos/VideoPlay.vue')

// ✅ 會員條款與隱私權政策（公開頁）
const TermsPrivacy  = () => import('../views/TermsPrivacy.vue')

// 嵌入頁
import TSKSyringe from '../components/product/TSKSyringe.vue'
import TskSelectNeedle from '../components/product/TskSelectNeedle.vue'

// Supabase（用於路由守門）
import { supabase } from '@/lib/supabase'

const defaultRoutes = [
  {
    path: '/',
    name: 'home',
    component: AllProduct
  },
  {
    path: '/institute',
    name: 'Institute',
    component: Institute
  },
  {
    path: '/AllProduct',
    name: 'AllProduct',
    component: AllProduct
  },
  {
    path: '/about',
    name: 'about',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/cookiepolicy',
    name: 'cookiepolicy',
    component: cookiepolicy
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/news/:id',
    name: 'NewsArticle',
    component: NewsArticle
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: Product
  },
  {
    path: '/member',
    name: 'Member',
    component: Member,
    meta: { title: '會員登入' }
  },

  // ✅ 公開：會員條款與隱私權政策（登入前後都可看）
  {
    path: '/terms',
    name: 'TermsPrivacy',
    component: TermsPrivacy,
    meta: { title: '會員條款與隱私權政策' }
  },

  // ===== 登入後主頁殼層（受保護） =====
  {
    path: '/app',
    component: AppShell,
    meta: { requiresAuth: true, title: '會員中心' },
    children: [
      { path: '', redirect: '/app/products' },

      // ★ 當期活動（需要 Verified）
      {
        path: 'promo',
        name: 'PromoList',
        component: PromoList,
        meta: { requiresAuth: true, requiresVerified: true, title: '當期活動' }
      },
      // ★ 當期活動細頁（需要 Verified）
      {
        path: 'promo/detail/:folder',
        name: 'PromoDetail',
        component: PromoListDetail,
        meta: { requiresAuth: true, requiresVerified: true, title: '活動詳情' }
      },

      // ★ 產品總覽（需要 Verified）
      {
        path: 'products',
        name: 'AppProducts',
        component: Products,
        meta: { requiresAuth: true, requiresVerified: true, title: '產品總覽' }
      },

      // ★ 產品細頁（需要 Verified）
      {
        path: 'product/:id',
        name: 'AppProduct',
        component: Product_detal,
        meta: { requiresAuth: true, requiresVerified: true, title: '產品內容' },
        props: true
      },

      {
        path: 'cart',
        name: 'AppCart',
        component: Cart,
        meta: { requiresAuth: true, title: '購物車' }
      },
      {
        path: 'profile',
        name: 'AppProfile',
        component: Profile,
        meta: { requiresAuth: true, title: '會員資料' }
      },
      {
        path: 'contact',
        name: 'AppContact',
        component: Contact,
        meta: { requiresAuth: true, title: '聯絡我們' }
      },
      // ★ 精選分享（論文列表，需要 Verified）
      {
        path: 'papers',
        name: 'AppPapers',
        component: Papers,
        meta: { requiresAuth: true, requiresVerified: true, title: '精選分享' }
      },
      // ★ 精選分享內的文章閱讀頁（需要 Verified）
      {
        path: 'papers/:id',
        name: 'AppPaperDetail',
        component: PaperDetail,
        meta: { requiresAuth: true, requiresVerified: true, title: '文章內容' },
        props: true
      },
      // ★ 醫師分享頁面（需要 Verified）
      {
         path: 'share',
        name: 'AppShare',
        component: Share,
        meta: { requiresAuth: true, requiresVerified: true, title: '醫師分享' }
      },
      // ★ 下載專區頁面（需要 Verified）
      {
         path: 'download',
        name: 'AppDownload',
        component: Download,
        meta: { requiresAuth: true, requiresVerified: true, title: '下載專區' }
      },
      // 🔥 索取試用頁面（需要 Verified）
      {
        path: 'trial',
        name: 'AppTrial',
        component: AppTrial,
        meta: { requiresAuth: true, requiresVerified: true, title: '索取試用' }
      },
      // ✅ 影音專區（需要 Verified）
      {
        path: 'videos',
        name: 'VideoIndex',
        component: VideoIndex,
        meta: { requiresAuth: true, requiresVerified: true, title: '注射療程精選影片' }
      },
      {
        path: 'videos/topic/:topicId',
        name: 'TopicVideos',
        component: TopicVideos,
        meta: { requiresAuth: true, requiresVerified: true, title: '注射療程精選影片' },
        props: true
      },
      {
        path: 'videos/subtopic/:subId',
        name: 'VideoSubtopic',
        component: SubtopicVideo,
        meta: { requiresAuth: true, requiresVerified: true, title: '注射療程精選影片' },
        props: true
      },
      {
        path: 'videos/:id',
        name: 'VideoPlay',
        component: VideoPlay,
        meta: { requiresAuth: true, requiresVerified: true, title: '精選影片播放' },
        props: true
      }
    ]
  }
]

const embedRoutes = [
  { path: '/TSY', name: 'EmbedTSKSyringe', component: TSKSyringe },
  { path: '/TSN', name: 'EmbedTskSelectNeedle', component: TskSelectNeedle }
]

const isEmbedMode = process.env.VUE_APP_MODE === 'embed'
const history = isEmbedMode ? createWebHashHistory(process.env.BASE_URL)
                            : createWebHistory(process.env.BASE_URL)

const router = createRouter({
  history,
  routes: isEmbedMode ? embedRoutes : defaultRoutes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  // ✨ Magic Link (hash) 入口處理：/#access_token=...&refresh_token=...&type=magiclink
  // 放在所有守門邏輯的最前面，避免被其他條件攔截
  if (!isEmbedMode && typeof to.hash === 'string' && to.hash.includes('access_token=')) {
    const hash = to.hash.startsWith('#') ? to.hash.slice(1) : to.hash
    const params = new URLSearchParams(hash)
    const type = params.get('type')
    const access_token = params.get('access_token')
    const refresh_token = params.get('refresh_token')
    // 允許外部在 query 上帶 redirect（若無則給 /app）
    const redirect = (typeof to.query.redirect === 'string' && to.query.redirect) || '/app'

    if (type === 'magiclink' && access_token && refresh_token) {
      try {
        const { error } = await supabase.auth.setSession({ access_token, refresh_token })
        if (error) throw error
        // 用 replace 清掉 hash，避免 token 殘留在歷史或被外送 referrer
        return next({ path: redirect, replace: true })
      } catch (e) {
        console.error('[router] magiclink setSession failed', e)
        return next({ name: 'Member', query: { reason: 'magiclink_failed' }, replace: true })
      }
    }
  }

  // 頁標題
  if (!isEmbedMode) {
    const defaultTitle = i18n.global.t('Title')
    document.title = to.meta?.title ? `${to.meta.title} | ${defaultTitle}` : defaultTitle
  }

  // Supabase 密碼重設 / 信箱登入恢復流程（舊式參數）
  const hasRecoveryTagInHash = typeof to.hash === 'string' && to.hash.includes('type=recovery')
  const hasRecoveryParams =
    !!to.query.code ||
    !!to.query.token_hash ||
    to.query.type === 'recovery' ||
    !!to.query.access_token
  const hasHoldFlag =
    typeof window !== 'undefined' && sessionStorage.getItem('recovery_hold') === '1'
  const isRecoveryFlow = hasRecoveryTagInHash || hasRecoveryParams || hasHoldFlag

  if (!isEmbedMode && isRecoveryFlow && to.name !== 'Member') {
    return next({
      name: 'Member',
      query: to.query,  // 把原本的 query 帶過去
      hash: to.hash     // ⭐ 把 hash（含 access_token, type=recovery）保留
    })
  }

  // 受保護頁面需要登入
  let sessionUser = null
  if (!isEmbedMode && to.matched.some(r => r.meta?.requiresAuth)) {
    try {
      const { data } = await supabase.auth.getSession()
      if (!data?.session) {
        return next({ name: 'Member', query: { redirect: to.fullPath } })
      }
      sessionUser = data.session.user
    } catch (e) {
      console.debug('[router] getSession (requiresAuth) ignored', e)
    }
  }

  // 已登入則不需再進登入頁
  if (!isEmbedMode && to.name === 'Member') {
    try {
      const { data } = await supabase.auth.getSession()
      if (data?.session && !isRecoveryFlow) {
        return next({ path: '/app' })
      }
    } catch (e) {
      console.debug('[router] getSession (member redirect) ignored', e)
    }
  }

  // ★ 影音頁：需要已通過帳號驗證
  if (!isEmbedMode && to.matched.some(r => r.meta?.requiresVerified)) {
    try {
      if (!sessionUser) {
        const { data } = await supabase.auth.getSession()
        sessionUser = data?.session?.user || null
      }
      if (!sessionUser) {
        return next({ name: 'Member', query: { redirect: to.fullPath } })
      }

      // 1) Email 是否已於 Auth 驗證（可視需求移除這個判斷）
      const emailOK = !!sessionUser.email && !!sessionUser.email_confirmed_at
      if (!emailOK) {
        return next({ name: 'AppProfile', query: { reason: 'email_not_verified' } })
      }

      // 2) 身份審核是否通過（你的 user_profiles 表）
      const { data: row, error } = await supabase
        .from('user_profiles')
        .select('identity_status')
        .eq('id', sessionUser.id)
        .maybeSingle()

      if (error) {
        console.warn('[router] load profile for verify failed', error)
        return next({ name: 'AppProfile', query: { reason: 'profile_load_failed' } })
      }

      if (row?.identity_status !== 'verified') {
        return next({ name: 'AppProfile', query: { reason: 'not_verified' } })
      }
    } catch (e) {
      console.warn('[router] requireVerified failed', e)
      return next({ name: 'AppProfile', query: { reason: 'unknown' } })
    }
  }

  return next()
})

export default router
